import styled from 'styled-components';

import { mediaQueryLaptopMin } from 'styles';

const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-flow: row wrap;
  width: 100%;

  @media all and ${mediaQueryLaptopMin} {
    padding-right: 16px;
    width: calc(100% - 310px);
  }
`;

export default Wrapper;
